import styled from 'styled-components';
import Heading from '@ids/components/Typography/Heading';

export const PressSection = styled.section`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    min-height: 160px;
`;

export const Title = styled(Heading)`
    text-align: center;
    margin: 0 1em 30px;
`;

export const ImagesContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
`;

export const ImageWrapper = styled.div`
    flex-basis: 140px;
    margin: 0 20px 20px;
`;
